import { render, staticRenderFns } from "./IbRequest.vue?vue&type=template&id=2a87b81a&scoped=true&"
import script from "./IbRequest.vue?vue&type=script&lang=js&"
export * from "./IbRequest.vue?vue&type=script&lang=js&"
import style0 from "./IbRequest.vue?vue&type=style&index=0&id=2a87b81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87b81a",
  null
  
)

export default component.exports